module.exports = __webpack_public_path__ + "static/media/block_icon.1d049a5f.svg";